// Public Flying legal text supplied on 4 October 2026.
export const LEGAL_FLYING_IMPRINT_EN: string = `
# Imprint / Legal Notice

## Provider

Bavaria2TM UG (haftungsbeschränkt)

Rickering 2a  
94577 Winzer  
Germany

Operator of Flying Research, Flying Upload and FLAI.

## Representation and commercial register

Represented by its managing director: Thomas Lösl

Commercial register: Amtsgericht Deggendorf  
Registration number: HRB 5115

## Contact

Email: [info@flyingupload.com](mailto:info@flyingupload.com)  
Telephone: [+49 176 56088926](tel:+4917656088926)

## VAT identification number

VAT identification number pursuant to section 27a of the German VAT Act: DE328647516

## Privacy contact

Thomas Lösl, at the company address above.  
Email: [info@flyingupload.com](mailto:info@flyingupload.com)

## Consumer dispute resolution

We are neither willing nor obliged to participate in dispute resolution proceedings before a consumer arbitration board.
`;
